import type { TableProps } from 'antd';
import { Breadcrumb, Button, Table } from 'antd';
import { FiPlus } from 'react-icons/fi';

import { Layout } from '../../components/layout';
import { ConfirmDeleteButton } from '../../components/confirm-delete-button';
import { DistributionListDrawer } from './components';
import type { DistributionListsProps, DistributionListType } from './DistributionLists.types.ts';

import './DistributionLists.styles.css';
import { BREADCRUMBS, DISTRIBUTION_LISTS_COLUMNS } from './DistributionLists.constants.tsx';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '../admin/components';
import { useEffect } from 'react';

export default function DistributionLists({
  distributionLists,
  isLoading,
  openDistributionListDrawer,
  onOpenDistributionListDrawer,
  onCloseDistributionListDrawer,
  onSubmitDistributionList,
  onDeleteDistributionLists,
  setSelectedDistributionListKeys,
  distributionListId,
  itemsToDeleteCount,
}: DistributionListsProps) {
  const { t } = useTranslation();
  const rowSelection: TableProps<DistributionListType>['rowSelection'] = {
    onChange: (selectedRowKeys: React.Key[]) => {
      setSelectedDistributionListKeys(selectedRowKeys);
    },
  };

  useEffect(() => {
    document.title = `Administration ${t('pages.admin.module.distribution-lists')}`;
  }, [t]);

  return (
    <Layout leftSidebar={null} rightSidebar={null}>
      {isLoading ? (
        <Skeleton />
      ) : (
        <div className="admin-page">
          <Breadcrumb className="breadcrumb" items={BREADCRUMBS} />

          <div className="admin-page-bar">
            <h1 className="admin-page-bar--title">{t('pages.admin.module.distribution-lists')}</h1>
            <div className="admin-page-bar--actions">
              <ConfirmDeleteButton
                onSubmit={onDeleteDistributionLists}
                count={itemsToDeleteCount}
                disabled={itemsToDeleteCount === 0}
              />
              <Button
                icon={<FiPlus />}
                iconPosition="start"
                size="large"
                type="primary"
                onClick={(event) => onOpenDistributionListDrawer(event, null)}
              >
                {t('common.add-new')}
              </Button>
            </div>
          </div>

          <Table<DistributionListType>
            rowKey="id"
            rowSelection={{ type: 'checkbox', ...rowSelection }}
            columns={DISTRIBUTION_LISTS_COLUMNS}
            dataSource={distributionLists}
            onRow={(record) => {
              return {
                onClick: (event: React.MouseEvent<HTMLButtonElement>) =>
                  onOpenDistributionListDrawer(event, record?.id || null),
              };
            }}
          />
          {openDistributionListDrawer && (
            <DistributionListDrawer
              open={openDistributionListDrawer}
              onClose={onCloseDistributionListDrawer}
              onSubmit={onSubmitDistributionList}
              distributionListId={distributionListId}
            />
          )}
        </div>
      )}
    </Layout>
  );
}
